/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Architecture16Inputs */

const en__field_enum_tuda_architecture16 = /** @type {(inputs: _Field_Enum_Tuda_Architecture16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const de__field_enum_tuda_architecture16 = /** @type {(inputs: _Field_Enum_Tuda_Architecture16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektur`)
};

/**
* | output |
* | --- |
* | "Architecture" |
*
* @param {_Field_Enum_Tuda_Architecture16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_architecture16 = /** @type {((inputs?: _Field_Enum_Tuda_Architecture16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Architecture16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_architecture16(inputs)
	return de__field_enum_tuda_architecture16(inputs)
});
export { _field_enum_tuda_architecture16 as "_field_enum_TUDA_ARCHITECTURE" }